"use strict";
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ODataQueryProvider = void 0;
var class_transformer_1 = require("class-transformer");
var odata_query_1 = require("./odata-query");
var shared_1 = require("./shared");
var ODataQueryProvider = /** @class */ (function () {
    function ODataQueryProvider(requestProvider) {
        this.requestProvider = requestProvider;
    }
    ODataQueryProvider.prototype.createQuery = function (parts) {
        return new odata_query_1.ODataQuery(this, parts);
    };
    ODataQueryProvider.prototype.execute = function (parts) {
        throw new Error("Synchronous execution is not supported");
    };
    ODataQueryProvider.prototype.executeAsync = function (parts) {
        var _a = __read(shared_1.handleParts(parts), 3), queryParams = _a[0], options = _a[1], ctor = _a[2];
        var promise = this.requestProvider.request(queryParams, options);
        return ctor
            ? promise.then(function (d) { return class_transformer_1.plainToClass(ctor, d); })
            : promise;
    };
    return ODataQueryProvider;
}());
exports.ODataQueryProvider = ODataQueryProvider;
//# sourceMappingURL=odata-query-provider.js.map